var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isLogin)?_c('div',{staticClass:"layoutCon"},[_c('div',{staticClass:"navCon"},[_c('nav-menu',{attrs:{"menu-arr":_vm.menuArr}})],1),_c('div',{staticClass:"content"},[_c('router-view')],1)]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }